var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"homeBanner"},[_c('el-carousel',{attrs:{"arrow":"never"}},[_vm._l((_vm.imgList),function(item,index){return _c('el-carousel-item',{key:index},[_c('img',{attrs:{"src":item.imgUrl,"alt":""}})])}),_c('img',{staticClass:"toolImg",attrs:{"src":_vm.imgHeight,"alt":""}})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }